import { useQuery } from "@tanstack/react-query";

import type { CollaboratorEntityT } from "../domain/entities/collaborator.entity";
import type { CollaboratorUiT } from "../domain/ui/collaborator.model";

import { CollaboratorsRepositoryT } from "../domain/ports/collaborators.repository";

import { getCollaborators } from "../application/useCases/getCollaborators";

import { formatEntryDate } from "./helpers";

const toUiModel = (data: CollaboratorEntityT[]): CollaboratorUiT[] =>
  data
    .filter((item) => item.statusEmployee === 0) // Filter to include only active collaborators
    .map((item) => ({
      id: item.id,
      code: item.code ?? null,
      fullName: item.fullName ?? null,
      status: item.statusText ?? null,
      entryDate: formatEntryDate(item.entryDate),
      entryDateTimestamp: item.entryDate
        ? new Date(item.entryDate).getTime()
        : null,
    }));

export const createUseCollaborators = ({
  collaboratorsRepository,
}: {
  collaboratorsRepository: CollaboratorsRepositoryT;
}) => {
  return function useCollaborators() {
    return useQuery({
      queryKey: ["shared/collaborators"],
      queryFn: () => getCollaborators({ collaboratorsRepository }),
      select: toUiModel,
    });
  };
};
